
export type WpTypes = 'wp' | 'theme' | 'plugin'

export interface Item {
    created_at: string;
    type: WpTypes;
    name: string;
    slug: string;
    oldVersion: string;
    newVersion: string;
}

export interface WPData {
    wp: Item[];
    theme: Item[];
    plugin: Item[];
}

export interface TotalCounts {
    modules: number;
    themes: number;
    wordPressBody: number;
    total: number;
}

export interface FullWPData {
    total: TotalCounts;
    wp: Item[];
    theme: Item[];
    plugin: Item[];
}

export const initialWPData: WPData = {
    wp: [],
    theme: [],
    plugin: []
};

export const initialFullWPData: FullWPData = {
    total: {
        modules: 0,
        themes: 0,
        wordPressBody: 0,
        total: 0
    },
    wp: [],
    theme: [],
    plugin: []
}